var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchListLayout',_vm._b({ref:"layout",staticClass:"d-employee-list",scopedSlots:_vm._u([{key:"searchFields",fn:function(ref){
var fieldsByName = ref.fieldsByName;
var action = ref.action;
return [_c('div',{staticClass:"\n\t\t\t\td-employee-list__search-fields\n\t\t\t\tgrid grid-cols-12\n\t\t\t\tgap-x-3xs/h gap-y-2xs/v\n\t\t\t\t>=1024:mt-8\n\t\t\t\tpt-lg/v\n\t\t\t\tpb-sm/v\n\t\t\t"},[_c('div',{staticClass:"col-span-12"},[(fieldsByName.text)?_c('SearchTextInput',_vm._b({nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function () { return _vm.submitText(fieldsByName, action.submit); }).apply(null, arguments)}},model:{value:(_vm.tempSearchValue.text),callback:function ($$v) {_vm.$set(_vm.tempSearchValue, "text", $$v)},expression:"tempSearchValue.text"}},'SearchTextInput',Object.assign({}, fieldsByName.text,
						{type: 'search'}),false),[_c('BaseButton',{staticClass:"\n\t\t\t\t\t\t\tw-48\n\t\t\t\t\t\t\t>=768:w-52\n\t\t\t\t\t\t\th-48\n\t\t\t\t\t\t\t>=768:h-52\n\t\t\t\t\t\t\tp-0\n\t\t\t\t\t\t\trounded-full\n\t\t\t\t\t\t",attrs:{"aria-label":"Udfør søgning"},on:{"click":function () { return _vm.submitText(fieldsByName, action.submit); }}},[_c('SvgIconSearch',{staticClass:"w-18 h-18"})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"\n\t\t\t\t\tcol-span-12\n\t\t\t\t\tgrid\n\t\t\t\t\t>=768:contents\n\t\t\t\t\tgrid-cols-12\n\t\t\t\t\tgap-8\n\t\t\t\t\t>=768:gap-x-3xs/h >=768:gap-y-2xs/v\n\t\t\t\t"},[(fieldsByName.areas)?_c('SearchDropdown',_vm._b({staticClass:"col-span-12 >=768:col-span-6",class:{
						'>=1200:col-span-4':
							fieldsByName.areas &&
							fieldsByName.departments &&
							fieldsByName.locations,
					},attrs:{"show-icon":""},on:{"input":function () { return action.submit(); }},model:{value:(fieldsByName.areas.value),callback:function ($$v) {_vm.$set(fieldsByName.areas, "value", $$v)},expression:"fieldsByName.areas.value"}},'SearchDropdown',fieldsByName.areas,false)):_vm._e(),_vm._v(" "),(fieldsByName.departments)?_c('SearchDropdown',_vm._b({staticClass:"col-span-12 >=768:col-span-6",class:{
						'>=1200:col-span-4':
							fieldsByName.areas &&
							fieldsByName.departments &&
							fieldsByName.locations,
					},on:{"input":function () { return action.submit(); }},model:{value:(fieldsByName.departments.value),callback:function ($$v) {_vm.$set(fieldsByName.departments, "value", $$v)},expression:"fieldsByName.departments.value"}},'SearchDropdown',fieldsByName.departments,false)):_vm._e(),_vm._v(" "),(fieldsByName.locations)?_c('SearchDropdown',_vm._b({staticClass:"col-span-12 >=768:col-span-6",class:{
						'>=1200:col-span-4':
							fieldsByName.areas &&
							fieldsByName.departments &&
							fieldsByName.locations,
					},on:{"input":function () { return action.submit(); }},model:{value:(fieldsByName.locations.value),callback:function ($$v) {_vm.$set(fieldsByName.locations, "value", $$v)},expression:"fieldsByName.locations.value"}},'SearchDropdown',fieldsByName.locations,false)):_vm._e()],1)])]}}])},'SearchListLayout',Object.assign({}, _vm.$props,
		_vm.$attrs,
		{headerGraphic: 2,
		searchArea: _vm.searchArea,
		searchConfig: {
			enableGroupedSearch: _vm.isGrouped,
			limit: _vm.isGrouped
				? {
						1: 6,
						2: 6,
						3: 6,
						4: 6,
						5: 6,
						6: 6, // don't know if there will be more than 5
						7: 6,
				  }
				: 12,
		},
		fetchMoreFunction: 'fetchAll',
		defaults: _vm.getDefaults({
			text: '',
			areas: '',
			departments: '',
			locations: '',
		}),
		hideLayoutPickerOnMobile: true,
		defaultLayout: 'list'}),false))}
var staticRenderFns = []

export { render, staticRenderFns }